<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_VARIANTS } from '../constants';

const { attachments, variant } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const bubbleClass = computed(() => 'bg-transparent');

const isPhone = computed(() => variant.value === MESSAGE_VARIANTS.PHONE);
</script>

<template>
  <BaseBubble :class="bubbleClass" data-bubble-name="audio">
    <div
      :class="isPhone ? 'bg-n-teal-4 rounded-xl' : ''"
    >
      <AudioChip
        :attachment="attachment"
        class="p-2 text-n-slate-12 skip-context-menu"
      />
    </div>
  </BaseBubble>
</template>
